var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHtlDockForMp3Filled = function SvgHtlDockForMp3Filled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4 15a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H4Zm0-1h8V6.5H4V14Zm2.449-1.574a.5.5 0 0 1-.45-.497V8.5a.5.5 0 0 1 .044-.207.514.514 0 0 1 .171-.239.5.5 0 0 1 .555-.034l3.006 1.747a.5.5 0 0 1-.01.87l-.018.01-2.992 1.71a.493.493 0 0 1-.256.071l-.05-.002Z"
  })));
};
export default SvgHtlDockForMp3Filled;